import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);

const Schema = ({
  description,
  title,
  imageUrls,
  insertedAt,
  creator,
}) => {
  const name = creator?.name;
  const schemaData = {
    '@context': 'http://schema.org',
    '@type': 'ImageObject',
    author: {
      '@type': 'Person',
      name,
    },
    datePublished: insertedAt && dayjs(insertedAt).format('l'),
    description,
    image: imageUrls[2],
    name: title,
  };
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
    />
  );
};

Schema.propTypes = {
  creator: PropTypes.shape({
    name: PropTypes.string,
  }),
  insertedAt: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string,
  imageUrls: PropTypes.arrayOf(PropTypes.string),
};

Schema.defaultProps = {
  creator: {
    name: '',
  },
  insertedAt: '',
  description: '',
  title: '',
  imageUrls: [],
};

export default Schema;
